<div class="cmn-dialog-card-view isCalanderDialog">
    <!-- Close -->
    <button class="dialog-close-btn" (click)="onCancelClick()">
        <img class="cross-icon" src="assets/svg/icons/cross.svg" />
    </button>

    <!-- Header -->
    <div class="dialog-header" *ngIf="content?.title">
        <h1 class="dialog-header-title-gradient">{{ content.title }}</h1>
        <div class="selected-date">
            <h3 *ngIf="['YYYY-MM', 'MM-DD', 'YYYY-MM-DD'].includes(content.type)">
                <span *ngIf="selectedDayValue" (click)="changeValue('DD')">
                    {{ selectedDayValue | number: "2.0" }},
                </span>

                <span *ngIf="selectedMonthValue" (click)="changeValue('MM')">
                    {{ moment(selectedMonthValue, "MM").format("MMM") }},
                </span>

                <span (click)="changeValue('YYYY')">
                    {{ selectedYearValue }}
                </span>
                <img class="icon icon-primary" src="assets/svg/icons/caret-down.svg" />
            </h3>
            <div class="direction-btn" [ngSwitch]="selectedType">
                <button
                    *ngSwitchCase="'YYYY'"
                    type="button"
                    class="primary-outline-btn arrow-btn"
                    (click)="previousYears()"
                >
                    <img class="" src="assets/svg/icons/chevron-up.svg" />
                </button>

                <button
                    *ngSwitchCase="'YYYY'"
                    type="button"
                    class="primary-outline-btn arrow-btn"
                    (click)="nextYears()"
                >
                    <img class="" src="assets/svg/icons/chevron-down.svg" />
                </button>
            </div>
        </div>
    </div>

    <!-- Body -->
    <mat-dialog-content>
        <div class="dialog-body" [ngSwitch]="selectedType">
            <!-- DAY -->
            <div *ngSwitchCase="'DD'" class="day-content">
                <div class="calender-day" *ngFor="let row of rows; trackBy: trackByIndex">
                    <button
                        *ngFor="let value of row"
                        type="button"
                        class="primary-fill-btn"
                        [disabled]="disabledDay(value)"
                        [class.is-active]="selectedDayValue === value"
                        (click)="select(value, 'DD')"
                    >
                        {{ value | number: "2.0" }}
                    </button>
                </div>
            </div>

            <!-- MONTH -->
            <div *ngSwitchCase="'MM'" class="month-content">
                <div class="calender-month" *ngFor="let row of rows; trackBy: trackByIndex">
                    <button
                        *ngFor="let value of row"
                        type="button"
                        class="primary-fill-btn"
                        [disabled]="disabledMonth(value)"
                        [class.is-active]="selectedMonthValue === value"
                        (click)="select(value, 'MM')"
                    >
                        {{ moment(value, "MM").format("MMM") }}
                    </button>
                </div>
            </div>

            <!-- YEAR -->
            <div *ngSwitchCase="'YYYY'" class="year-content">
                <div class="calender-year" *ngFor="let row of rows; trackBy: trackByIndex">
                    <button
                        *ngFor="let value of row"
                        type="button"
                        class="primary-fill-btn"
                        [disabled]="disabledYear(value)"
                        [class.is-active]="selectedYearValue === value"
                        (click)="select(value, 'YYYY')"
                    >
                        {{ value }}
                    </button>
                </div>
            </div>

            <!-- ACTION -->
            <div class="dialog-actions">
                <div class="dialog-actions-btn">
                    <button
                        type="button"
                        class="primary-fill-btn btn-w100"
                        (click)="onConfirmClick()"
                        [disabled]="
                            (selectedType === 'DD' && !selectedDayValue) ||
                            (selectedType === 'MM' && !selectedMonthValue)
                        "
                    >
                        {{ content?.confirmButtonName || "Save" }}
                    </button>
                </div>
            </div>
        </div>
    </mat-dialog-content>
</div>
